import {definePreset} from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const mydealsPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#eff6ff',
      100: '#dbeafe',
      200: '#bfdbfe',
      300: '#93c5fd',
      400: '#60a5fa',
      500: '#171717',
      600: '#171717',
      700: '#1d4ed8',
      800: '#1e40af',
      900: '#1e3a8a',
      950: '#172554',
    },
    colorScheme: {
      light: {
        formField: {
          floatLabelFocusColor: '{surface.500}',
        },
      },
    },
  },
});
